import { useLayoutContext } from "@context/layout";
import { Button } from "@shared/components";
import { BUTTON_SIZE, BUTTON_VARIANT } from "@shared/components/button";
import useSubscriptionExperiments from "@shared/hooks/useSubscriptionExperiments";
import SubscriptionShineIcon from "@svg/new-design/SubscriptionShineIcon";
import { FC } from "react";

const HeaderSubscriptionButton: FC = () => {
  const { handleLogExperimentSubRecommender } = useSubscriptionExperiments();
  const { userData, subscriptionData } = useLayoutContext();

  const isLoggedIn = Boolean(userData?.is_login);
  const hasActiveSubscription = Boolean(subscriptionData?.is_active);

  if (hasActiveSubscription || !isLoggedIn) return null;
  return (
    <div className="hidden lg:flex subscription-gradient-border justify-center">
      <Button
        className="whitespace-nowrap subscription-button-bg-light border-0 text-fds-brand-select h-full"
        variant={BUTTON_VARIANT.OUTLINE}
        size={BUTTON_SIZE.MEDIUM}
        href="/subscription"
        startIcon={
          <div className="relative w-4 h-4">
            <SubscriptionShineIcon
              className="absolute inset-0 h-full w-full"
              aria-hidden="true"
            />
          </div>
        }
        onClick={() =>
          handleLogExperimentSubRecommender({ position: "header-btn" })
        }
      >
        اشتراک فرادرس
      </Button>
    </div>
  );
};

export default HeaderSubscriptionButton;
